import { Post as Content } from '@/types/redux/kol-content'
import { Post } from '@/types/schema/api/radar-search-post'
import { MatchedPost } from '@/types/schema/kol-schema'
import { PostCollectionPost } from '@/types/schema/post-collection'
import {
  convertPlatformShortcode,
  convertPlatformType,
  PlatformCode,
} from '@/utils/convert-platform'
import env from '@/utils/env'

type GetImageUrlFromApiServer = (
  platform: PlatformCode,
  crawlerId: string,
  postId: string,
  igPostId: string,
) => string

export const getImageUrlFromApiServer: GetImageUrlFromApiServer = (
  platform,
  crawlerId,
  postId,
  igPostId,
) => {
  const imageId = igPostId !== '' ? igPostId : postId
  return `${env.PUBLIC_K6RSATELLITE_API_BASE_URL}/v1/${platform}/${crawlerId}/post/${imageId}/thumbnail`
}

type GetContentImageUrlFromApiServer = (
  content: Pick<Content, 'platformType' | 'crawledID' | 'postID' | 'igPostId'>,
) => string

export const getContentImageUrlFromApiServer: GetContentImageUrlFromApiServer =
  (content) => {
    const { platformType, crawledID, postID, igPostId } = content
    const platform = convertPlatformType(platformType)?.code

    if (platform === undefined) {
      return ''
    }
    return getImageUrlFromApiServer(platform, crawledID, postID, igPostId)
  }

type GetPostImageUrlFromApiServer = (post: Post) => string

export const getPostImageUrlFromApiServer: GetPostImageUrlFromApiServer = (
  post,
) => {
  const { platform_type, crawled_id, post_id, ig_post_id } = post
  const platform = convertPlatformType(platform_type)?.code

  if (platform === undefined) {
    return ''
  }
  return getImageUrlFromApiServer(platform, crawled_id, post_id, ig_post_id)
}

type GetCollectionImageUrlFromApiServer = (
  collectionPost: Pick<
    PostCollectionPost,
    'platform_type' | 'crawler_id' | 'post_id' | 'ig_post_id'
  >,
) => string

export const getCollectionImageUrlFromApiServer: GetCollectionImageUrlFromApiServer =
  (collectionPost) => {
    const { platform_type, crawler_id, post_id, ig_post_id } = collectionPost
    const platform = convertPlatformShortcode(platform_type)

    if (platform.title === '') {
      return ''
    }
    return getImageUrlFromApiServer(
      platform.code,
      crawler_id,
      post_id,
      ig_post_id,
    )
  }

type GetMatchedPostImageUrlFromApiServer = (
  post: Pick<MatchedPost, 'postId' | 'platformType' | 'crawledId' | 'igPostId'>,
) => string

export const getMatchedPostImageUrlFromApiServer: GetMatchedPostImageUrlFromApiServer =
  (collectionPost) => {
    const { platformType, crawledId, postId, igPostId } = collectionPost
    const platform = convertPlatformType(platformType)

    if (platform === undefined) {
      return ''
    }
    return getImageUrlFromApiServer(platform.code, crawledId, postId, igPostId)
  }
